/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalMessagesSortBy =
    (typeof GetApiDoctorsPortalMessagesSortBy)[keyof typeof GetApiDoctorsPortalMessagesSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalMessagesSortBy = {
    validFrom: 'validFrom',
    validUntil: 'validUntil',
    title: 'title',
    priority: 'priority',
    isPinned: 'isPinned',
    createdAt: 'createdAt',
} as const;
